import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-evo-mastery-bar',
  templateUrl: './evo-mastery-bar.component.html',
  styleUrls: ['./evo-mastery-bar.component.css']
})
export class EvoMasteryBarComponent implements OnInit {

  @Input() red = 0;
  @Input() yellow = 0;
  @Input() purple = 0;
  @Input() green = 0;
  @Input() blue = 0;

  constructor() { }

  ngOnInit() {
  }

  percentageString(value: number): string {
    return value.toFixed(2);
  }

}
